import { render, staticRenderFns } from "./ChargeManage.vue?vue&type=template&id=3b869622&scoped=true&"
import script from "./ChargeManage.vue?vue&type=script&lang=js&"
export * from "./ChargeManage.vue?vue&type=script&lang=js&"
import style0 from "./ChargeManage.vue?vue&type=style&index=0&id=3b869622&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b869622",
  null
  
)

export default component.exports